import { FormattedMessage } from 'react-intl';
import HeadToTheAppDialogBase from './HeadToTheAppDialogBase';

type Props = {
  onCloseRequest: () => void;
  provider: 'apple' | 'google';
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=7373-65685&t=R6dqqUgBb8OhoksN-0
export default function HeadToTheAppDialog({ onCloseRequest, provider }: Props) {
  return <HeadToTheAppDialogBase onCloseRequest={onCloseRequest} provider={provider} text={<FormattedMessage defaultMessage="Maybe later" />} />;
}
